import React from 'react';
import UserPill from './UserPill';

export default function RoleSignupList({
  label,
  names = [],
  isSigningUp = false,
  userNameInput = "",
  onUserNameChange,
  onStartSignup,
  onConfirmSignup,
  onCancelSignup,
  onLeave,
  users = [],
  buttonLabel = "+ Join",
  borderColor = "rgba(2, 132, 199, 0.18)",
  accentColor = "var(--color-primary)"
}) {
  return (
    <div style={{ background: 'rgba(255,255,255,0.01)', border: `1px solid ${borderColor}`, borderRadius: '8px', padding: '12px', width: '100%', boxSizing: 'border-box' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
        <span style={{ fontSize: '0.75rem', fontWeight: '700', color: 'var(--color-accent)', fontFamily: 'var(--font-body)', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
          {label} ({names.length})
        </span>
      </div>

      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', alignItems: 'center' }}>
        {names.map((name, index) => (
          <UserPill
            key={index}
            id={name}
            users={users}
            onRemove={onLeave}
          />
        ))}

        {isSigningUp ? (
          <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
            <select
              className="input-field"
              value={userNameInput}
              onChange={e => onUserNameChange(e.target.value)}
              style={{ padding: '4px 8px', fontSize: '0.8rem', width: '120px', borderRadius: '6px', height: 'auto', lineHeight: 'normal', fontFamily: 'var(--font-body)' }}
            >
              {users.map(u => (
                <option key={u.id} value={u.id}>{u.name}</option>
              ))}
            </select>
            <button className="btn-primary" style={{ padding: '4px 8px', fontSize: '0.8rem', borderRadius: '6px', fontFamily: 'var(--font-body)' }} onClick={onConfirmSignup}>
              ✓
            </button>
            <button className="btn-secondary" style={{ padding: '4px 8px', fontSize: '0.8rem', borderRadius: '6px', fontFamily: 'var(--font-body)' }} onClick={onCancelSignup}>
              ✕
            </button>
          </div>
        ) : (
          <button className="btn-role-signup" style={{ padding: '4px 10px', fontSize: '0.8rem', borderRadius: '20px', border: `1px dashed ${accentColor}`, background: 'none', color: accentColor, cursor: 'pointer', transition: 'all 0.2s', fontFamily: 'var(--font-body)' }} onClick={onStartSignup}>
            {buttonLabel}
          </button>
        )}
      </div>
    </div>
  );
}
